export const day = [
  { value: "01", label: "1" },
  { value: "02", label: "2" },
  { value: "03", label: "3" },
  { value: "04", label: "4" },
  { value: "05", label: "5" },
  { value: "06", label: "6" },
  { value: "07", label: "7" },
  { value: "08", label: "8" },
  { value: "09", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
  { value: "26", label: "26" },
  { value: "27", label: "27" },
  { value: "28", label: "28" },
  { value: "29", label: "29" },
  { value: "30", label: "30" },
  { value: "31", label: "31" },
];
export const month = [
  { value: "01", label: "มกราคม" },
  { value: "02", label: "กุมภาพันธ์" },
  { value: "03", label: "มีนาคม" },
  { value: "04", label: "เมษายน" },
  { value: "05", label: "พฤษภาคม" },
  { value: "06", label: "มิถุนายน" },
  { value: "07", label: "กรกฎาคม" },
  { value: "08", label: "สิงหาคม" },
  { value: "09", label: "กันยายน" },
  { value: "10", label: "ตุลาคม" },
  { value: "11", label: "พฤศจิกายน" },
  { value: "12", label: "ธันวาคม" },
];
export const selectorigin = [
  { value: "000", label: "ไม่มีเชื้อชาติ" },
  { value: "099", label: "ไทย" },
  { value: "044", label: "จีน" },
  { value: "048", label: "พม่า" },
  { value: "056", label: "ลาว" },
  { value: "050", label: "มาเลเซีย" },
  { value: "994", label: "อื่นๆ" },
];
export const selectreligion = [
  { value: "00", label: "ไม่มีศาสนา" },
  { value: "01", label: "พุทธ" },
  { value: "02", label: "อิสลาม" },
  { value: "03", label: "ฮินดู" },
  { value: "04", label: "ยิว" },
  { value: "05", label: "ซิกซ์" },
  { value: "06", label: "คริสต์" },
  { value: "07", label: "เชน" },
  { value: "08", label: "โซโรอัสเตอร์" },
  { value: "09", label: "บาไฮ" },
];
export const firstgen = [
  { value: "1", label: "ใช่" },
  { value: "0", label: "ไม่ใช่" },
];
export const objTypePre_Bak = [
  { value: "1", label: "บิดา" },
  { value: "2", label: "มารดา" },
  { value: "3", label: "ผู้ปกครอง" },
];
export const selecnation = [
  { value: "XX", label: "ไม่มีสัญชาติ | NO Nationality" },
  { value: "TH", label: "ไทย | Thai" },
  { value: "CN", label: "จีน | China" },
  { value: "LA", label: "ลาว | Lao" },
  { value: "MY", label: "มาเลเซีย | Malasia" },
  { value: "MM", label: "พม่า | Myanmar" },
  { value: "KH", label: "กัมพูชา | Cambodian" },
  { value: "ZZ", label: "อื่นๆ | Other" },
];
